import Http from '../http'

export const index = (page, name) => Http.get(`/carts?page=${page}${(name) ? '&name=' + name : ''}`, { headers: { Authorization: localStorage.token } })
export const store = (data) => Http.post('/carts', { data }, { headers: { Authorization: localStorage.token } })
export const update = (id, data) => Http.patch(`/carts/${id}`, { data }, { headers: { Authorization: localStorage.token } })
export const destroy = (id) => Http.delete(`/carts/${id}`, { headers: { Authorization: localStorage.token } })
